import { HTMLAttributes } from 'react';
import { useCustomNavigate } from '@/website/hooks/useCustomNavigate';
import { Routes } from '@/website/util/routes';
import { JoveButton } from '@jove-frontend/mui';
import { useJoveBreakpoint } from '@jove-frontend/uikit';
import { ArrowCircleRight, ManageSearch, PeopleAlt, SmartToy } from '@mui/icons-material';
import { Box, Container, Typography } from '@mui/material';
import clsx from 'clsx';

type HowWeGetBestPriceProps = HTMLAttributes<HTMLDivElement> & { post?: any };

const HowWeGetBestPrice = (props: HowWeGetBestPriceProps) => {
  const { className, post } = props;
  const { push } = useCustomNavigate();
  const { isMobileLayout } = useJoveBreakpoint();

  const handleSwitchToJove = () => {
    push({ path: Routes.switchToJoveUploadPolicyDocuments() });
  };

  const features = [
    {
      icon: <SmartToy className="text-brand-secondary h-8 w-8" />,
      title: post?.bestPriceFeature1Title,
      description: post?.bestPriceFeature1Description,
    },
    {
      icon: <PeopleAlt className="text-brand-secondary h-8 w-8" />,
      title: post?.bestPriceFeature2Title,
      description: post?.bestPriceFeature2Description,
    },
    {
      icon: <ManageSearch className="text-brand-secondary h-8 w-8" />,
      title: post?.bestPriceFeature3Title,
      description: post?.bestPriceFeature3Description,
    },
  ];

  return (
    <Box className={clsx('w-full py-16', className)}>
      <Box component={Container} className="flex flex-col items-center space-y-12">
        {/* Header Section */}
        <Box className="flex flex-col items-center space-y-4">
          <Box className="bg-light-blue inline-block rounded-full px-4 py-1.5">
            <Typography variant="subtitle1" className="text-brand-secondary font-bold">
              {post?.pricingBadge}
            </Typography>
          </Box>
          <Typography className="text-primary-black font-serif text-[52px] font-black leading-tight">
            {post?.bestPriceTitle}
          </Typography>
          <Typography variant="h6" className="text-primary-black font-medium">
            {post?.bestPriceSubtitle}
          </Typography>
        </Box>

        {/* Features Section */}
        <Box className={clsx('w-full gap-6 px-4', isMobileLayout ? 'flex flex-col' : 'grid grid-cols-3')}>
          {features.map((feature, index) => (
            <Box key={index} className="bg-light-blue flex flex-col space-y-4 rounded-2xl p-6">
              {/* Icon */}
              <Box className="flex h-12 w-12 items-center justify-center rounded-xl bg-white">{feature.icon}</Box>

              {/* Title */}
              <Typography variant="h5" className="text-primary-black font-bold">
                {feature.title}
              </Typography>

              {/* Description */}
              <Typography className="text-primary-black text-lg font-medium leading-tight">{feature.description}</Typography>
            </Box>
          ))}
        </Box>

        {/* Button */}
        <JoveButton size="large" variant="contained" endIcon={<ArrowCircleRight />} onClick={handleSwitchToJove}>
          {post?.switchToJoveButton}
        </JoveButton>
      </Box>
    </Box>
  );
};

export default HowWeGetBestPrice;
